const INSTALLMENTS_BY_CODE: Record<string, number> = {
  "PaymentMethod.MONTHLY": 12,
  "PaymentMethod.QUARTERLY": 4,
  "PaymentMethod.SEMESTERLY": 2,
  "PaymentMethod.ANNUALLY": 1,
  "PaymentMethod.ONE_TIME": 1,
  "PaymentMethod.INDIVIDUAL": 1,
};

// taxonomy = redux s.taxonomy; paymentMethodCode = numeric id from the row
export const getInstallmentCount = (
  taxonomy: any,
  paymentMethodCode: any
): number => {
  const code = taxonomy?.PaymentMethod?.byId?.[paymentMethodCode]?.code;
  return INSTALLMENTS_BY_CODE[code] ?? 1;
};

export const getBookingAmount = (
  annualValue: number | null | undefined,
  taxonomy: any,
  paymentMethodCode: any
): number | null => {
  if (annualValue === null || annualValue === undefined) return null;
  return annualValue / getInstallmentCount(taxonomy, paymentMethodCode);
};

// Sum of all individual installment amounts.
// Assistance/accident/legal use the MTPL payment method (supplementary to MTPL).
export const getTotalBookingAmount = (
  row: any,
  taxonomy: any
): number | null => {
  if (!row) return null;
  const parts = [
    getBookingAmount(row.mtplAnnualGrossPremium, taxonomy, row.mtplPaymentMethod),
    getBookingAmount(row.hullAnnualGrossPremium, taxonomy, row.hullPaymentMethod),
    getBookingAmount(row.assistanceAnnualGrossPremium, taxonomy, row.mtplPaymentMethod),
    getBookingAmount(row.accidentAnnualGrossPremium, taxonomy, row.mtplPaymentMethod),
    getBookingAmount(row.legalAnnualGrossPremium, taxonomy, row.mtplPaymentMethod),
    getBookingAmount(row.fleetLegalAnnualGrossPremium, taxonomy, row.fleetLegalPaymentMethod),
    getBookingAmount(row.horsePowerBasedTaxAnnualy, taxonomy, row.horsePowerBasedTaxPaymentMethod),
    getBookingAmount(row.hullOnLandAnnualGrossPremium, taxonomy, row.hullOnLandPaymentMethod),
    getBookingAmount(row.machineryBreakdownAnnualGrossPremium, taxonomy, row.machineryBreakdownPaymentMethod),
  ].filter((v): v is number => v !== null);
  if (parts.length === 0) return null;
  return parts.reduce((a, b) => a + b, 0);
};
